(function ($, Global) {
    function AccordionLanding() {
        // Déclaration class objet
    }

    AccordionLanding.prototype.initEvents = function () {
        this.publishers();
    }

    AccordionLanding.prototype.publishers = function () {
        $(document).on('show.bs.collapse', '#accordionLanding', function () {
            $('#accordionLanding .collapse.show').collapse('hide');
        });

        $(document).on('show.bs.collapse', '#accordionLanding .bloc-free-account', function () {
            $(this).find('.btn-link.underline').addClass('hidden-xs');
        });

        $(document).on('hide.bs.collapse', '#accordionLanding .bloc-free-account', function () {
            $(this).find('.btn-link.underline').removeClass('hidden-xs');
        });


        $(document).on('click', '#accordionLanding [data-toggle="collapse"]', function (e) {
            if ($('#accordionLanding .collapse.show').length == 1 && $(this).parent().find('.collapse').hasClass('show')) {
                e.preventDefault();
            } else {
                $(this).parent().find('.collapse').collapse('toggle');
            }
        });
    }

    Global.AccordionLanding = AccordionLanding;
}(jQuery, window));